/* map.svelte.ts generated by Svelte v5.55.4 */
import * as $ from 'svelte/internal/client';

class MapStore {
	#instance = $.state(null);

	get instance() {
		return $.get(this.#instance);
	}

	set instance(value) {
		$.set(this.#instance, value, true);
	}

	#zoom = $.state(2);

	get zoom() {
		return $.get(this.#zoom);
	}

	set zoom(value) {
		$.set(this.#zoom, value, true);
	}

	#plane = $.state(0);

	get plane() {
		return $.get(this.#plane);
	}

	set plane(value) {
		$.set(this.#plane, value, true);
	}

	#showCoords = $.state(true);

	get showCoords() {
		return $.get(this.#showCoords);
	}

	set showCoords(value) {
		$.set(this.#showCoords, value, true);
	}

	get ready() {
		return this.instance !== null;
	}

	setInstance(map) {
		this.instance = map;
		this.zoom = map.getZoom();
		this.plane = map.getPlane();

		map.on("zoomend", () => {
			this.zoom = map.getZoom();
		});

		map.on("planechange", (e) => {
			this.plane = e.newPlane;
		});
	}

	zoomIn() {
		this.instance?.zoomIn();
	}

	zoomOut() {
		this.instance?.zoomOut();
	}

	planeUp() {
		if (this.plane < 3) this.instance?.setPlane(this.plane + 1);
	}

	planeDown() {
		if (this.plane > 0) this.instance?.setPlane(this.plane - 1);
	}

	toggleFullscreen() {
		if (document.fullscreenElement) {
			document.exitFullscreen();
		} else {
			document.getElementById("app")?.requestFullscreen();
		}
	}
}

export const mapStore = new MapStore();